<template>
    <AppSeoTags></AppSeoTags>

    <AppNavbar @toggle-mobile-nav="showMobileNav = !showMobileNav" :mobile-nav-shown="showMobileNav"></AppNavbar>

    <MobileNavigation @close="showMobileNav = false" :show="showMobileNav"></MobileNavigation>

    <AppContainer class="py-0">
        <MessageAlerts></MessageAlerts>
    </AppContainer>

    <main class="transition" :class="{'-translate-x-full': showMobileNav, 'overflow-hidden': showMobileNav}">
        <slot></slot>
    </main>

    <CookieBanner></CookieBanner>

    <AppFooter></AppFooter>
</template>

<script>
import AppNavbar from "@/Components/AppNavbar.vue";
import AppFooter from "@/Components/AppFooter.vue";
import MobileNavigation from "@/Components/MobileNavigation";
import AppContainer from "@/Layouts/AppContainer";
import MessageAlerts from "@/Components/MessageAlerts";
import AppSeoTags from "@/Components/AppSeoTags";
import CookieBanner from "@/Components/CookieBanner";

export default {
    components: {
        CookieBanner,
        AppSeoTags,
        MessageAlerts,
        AppContainer,
        MobileNavigation,
        AppNavbar,
        AppFooter
    },
    data() {
        return {
            showMobileNav: false
        };
    },
    watch: {
        showMobileNav(open) {
            const body = document.querySelector("body");

            // If nav is open, add overflow-hidden to body to prevent scrolling
            if (open) {
                body.classList.add("overflow-hidden");
            } else {
                body.classList.remove("overflow-hidden");
            }
        }
    }
};
</script>

<style scoped>
</style>
